import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from '@common/hooks/translation';
import Config from '@app/dev/config/main';

import './style.scss';

const ClientTransaction = () => {
  const t = useTranslation();

  return (
    <div className="ct-form ct-welcome-form">
      <h3 className="ct-form-title">{t('Welcome')}</h3>
      <p className="ct-form-subtitle">{t('Select the transaction you want to complete')}</p>
      <div className="ct-form-buttons">
        {Config.clientTransaction.enableClientWithdraw && <Link to="/clientTransaction/withdraw">
          <i className="global-icon icon-terminal-withdraw" />
          {t('Withdraw')}
        </Link>}

        <Link to="/clientTransaction/deposit" className="ct-form-submit-btn">
          <i className="global-icon icon-terminal-deposit" />
          {t('Deposit')}
        </Link>
      </div>
    </div>
  );
};

export default ClientTransaction;
